module.exports = __webpack_public_path__ + "static/apto-103-nw-f48b77af7084c65ef09c680e18afba92.jpg";